(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[905],{

/***/ 5159:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[slug]",
      function () {
        return __webpack_require__(4772);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/General/Button.tsx
var Button = __webpack_require__(3607);
// EXTERNAL MODULE: ./src/components/General/Input.tsx
var Input = __webpack_require__(348);
// EXTERNAL MODULE: ./src/constants/api-endpoints.ts
var api_endpoints = __webpack_require__(474);
// EXTERNAL MODULE: ./src/utils/helpers.ts + 2 modules
var helpers = __webpack_require__(4143);
// EXTERNAL MODULE: ./src/utils/access-token.js
var access_token = __webpack_require__(5276);
// EXTERNAL MODULE: ./src/utils/axios.ts + 41 modules
var axios = __webpack_require__(2644);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(2175);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(4231);
;// CONCATENATED MODULE: ./src/validations/Bid.ts

const BidCreateSchema = yup_es/* object */.Ry({
    bid_quantity: yup_es/* number */.Rx().required("Bid QTY is required!").nullable().typeError("Bid Quantity must be a valid number!").moreThan(0, "Bid Quantity must be greater than zero!")
});
const directPurchaseSchema = yup_es/* object */.Ry({
    quantity: yup_es/* number */.Rx().required("Quantity is required!").nullable().typeError("Quantity must be a valid number!")
});
/* harmony default export */ var Bid = (BidCreateSchema);

// EXTERNAL MODULE: ./src/store/ConfirmationSlice.js
var ConfirmationSlice = __webpack_require__(605);
// EXTERNAL MODULE: ./src/store/ToastSlice.js
var ToastSlice = __webpack_require__(6497);
// EXTERNAL MODULE: ./src/styles/APIDetails/[slug].module.css
var _slug_module = __webpack_require__(1739);
var _slug_module_default = /*#__PURE__*/__webpack_require__.n(_slug_module);
// EXTERNAL MODULE: ./src/constants/MixPanelEvents.ts
var MixPanelEvents = __webpack_require__(4416);
// EXTERNAL MODULE: ./src/MixPanel.ts
var MixPanel = __webpack_require__(5067);
;// CONCATENATED MODULE: ./src/components/APIDetails/deal-card.tsx
















function PDPDealCard(param) {
    let { data , resetCard , user , openDialog  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { confirm , from  } = (0,es/* useSelector */.v9)((state)=>state.confirmation);
    const [payload, setPayload] = (0,react.useState)({});
    const [shrinkedList, setShrinkedList] = (0,react.useState)(true);
    const initialValues = {
        bid_quantity: null
    };
    const { values , errors , handleSubmit , handleBlur , handleChange , touched , resetForm  } = (0,formik_esm/* useFormik */.TA)({
        initialValues: initialValues,
        validationSchema: Bid,
        onSubmit: (values, action)=>{
            let payload = {
                unit: data.minimum_quantity_unit_details.id,
                deal: data.id
            };
            payload = {
                ...payload,
                ...values
            };
            setPayload(payload);
            const confirmationData = {
                from: "PDPDealCard",
                details: "You are placing a bid for ".concat(values.bid_quantity, " ").concat(data.minimum_quantity_unit_details.name, " of ").concat(data.product_details.product_details.name, " (").concat(data.product_details.product_details.cas_number, ").")
            };
            dispatch((0,ConfirmationSlice/* showConfirmationBox */.HQ)(confirmationData));
        }
    });
    (0,react.useEffect)(()=>{
        if (confirm && from === "PDPDealCard" && data.id == payload.deal) {
            submitBid(payload);
        }
    }, [
        confirm,
        from
    ]);
    const submitBid = (payload)=>{
        const mixPanelData = {
            bidQuantity: payload.bid_quantity,
            dealID: payload.deal
        };
        const endPoint = helpers/* default.getAPIEndpoint */.Z.getAPIEndpoint(api_endpoints/* default.bidCreate */.Z.bidCreate);
        const headers = {
            "Authorization": "Bearer ".concat(access_token/* default.getAccessToken */.Z.getAccessToken())
        };
        const successHandler = (response)=>{
            resetForm();
            resetCard();
            dispatch((0,ToastSlice/* setSnackBar */.c6)({
                color: "success",
                message: "Your bid has been successfully made!"
            }));
            mixPanelData["status"] = MixPanelEvents/* MixPanelConstants.SUCCESS */.f.SUCCESS;
            MixPanel/* MixpanelTracking.getInstance */.n.getInstance().bid(mixPanelData);
        };
        const errorHandler = (error)=>{
            console.log(error);
            dispatch((0,ToastSlice/* setSnackBar */.c6)({
                color: "error",
                message: error.response.data.detail[0]
            }));
            mixPanelData["status"] = MixPanelEvents/* MixPanelConstants.FAILED */.f.FAILED;
            mixPanelData["reason"] = error.response.data.detail[0];
            MixPanel/* MixpanelTracking.getInstance */.n.getInstance().bid(mixPanelData);
        };
        axios/* default.requestPOST */.Z.requestPOST(endPoint, payload, headers, successHandler, errorHandler);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            border: "0.5px solid rgba(170, 170, 170, 0.5)"
        },
        className: "bg-white px-3 pt-3 pb-4 mb-4 w-[100%] rounded-[5px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                children: !user.isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((_slug_module_default()).BlurSmallImage, " h-14 mb-3")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "name__date flex justify-between items-start mb-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "price__bid flex items-center ".concat(data.deal_price ? "justify-between" : "justify-end"),
                            children: data.deal_price && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        className: "text-2xl font-bold text-theme-black",
                                        children: [
                                            "$",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    data.deal_price,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "font-light text-theme-black",
                                                        style: {
                                                            fontSize: 12
                                                        },
                                                        children: [
                                                            " / ",
                                                            data.deal_quantity_unit_details.name,
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                        className: "text-theme-black opacity-70 block",
                                        style: {
                                            marginTop: -5
                                        },
                                        children: " Deal Price "
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "date text-right",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                    className: "block text-theme-black font-semibold pt-2 ".concat(data.days_left.days <= 5 && "text-[#A9342E]"),
                                    style: {
                                        fontSize: "0.9rem"
                                    },
                                    children: [
                                        " ",
                                        data.deal_closure_date,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "block text-theme-black opacity-70",
                                    children: " Bid End Date "
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "progress-details px-3 py-2 pt-4 mt-1 mb-3 bg-white",
                style: {
                    borderRadius: 9
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "quantity__price flex justify-between items-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-theme-black font-semibold leading-3",
                                        style: {
                                            fontSize: "0.9rem"
                                        },
                                        children: [
                                            data.minimum_bid_quantity,
                                            " ",
                                            data.minimum_quantity_unit_details.name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                        className: "text-theme-black",
                                        style: {
                                            fontSize: 12
                                        },
                                        children: "Min. Bid QTY"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-right",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-theme-black font-semibold leading-3",
                                        style: {
                                            fontSize: 19
                                        },
                                        children: [
                                            data.deal_quantity,
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                style: {
                                                    fontSize: 13
                                                },
                                                className: "font-normal",
                                                children: [
                                                    " ",
                                                    data.deal_quantity_unit_details.name,
                                                    " "
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                        className: "text-theme-black",
                                        style: {
                                            fontSize: 12
                                        },
                                        children: "Deal Activation QTY"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "progress mt-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            style: {
                                width: "100%",
                                height: "7px",
                                borderRadius: 9,
                                background: "rgba(219, 107, 43, 0.15)"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-right",
                                style: {
                                    background: "rgba(219, 107, 43, 0.63)",
                                    width: "".concat(data.total_commitment_in_percentage.commited, "%"),
                                    height: "7px",
                                    borderTopLeftRadius: 9,
                                    borderBottomLeftRadius: 9
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-end mt-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                            className: "text-theme-black",
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "font-semibold opacity-100",
                                    children: [
                                        data.total_commitment_in_percentage.commited,
                                        "%"
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "opacity-80",
                                    children: "Completed"
                                }),
                                " "
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between py-2 rounded-[2px] px-2 lg:py-2 bg-[#F7F7F7] mb-[6px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] lg:w-[48%]",
                        children: "Pharmacopeia grades"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] font-[700]",
                        children: data.product_details.pharmacopoeia_grade_list.map((certificate, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    certificate.name,
                                    index === data.product_details.pharmacopoeia_grade_list.length - 1 ? "" : " / "
                                ]
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between py-2 rounded-[2px] px-2 lg:py-2 bg-[#F7F7F7] mb-[13px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] lg:w-[48%]",
                        children: "Quality certificates"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] font-[700]",
                        children: data.product_details.certificate_list.map((certificate, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    certificate.name,
                                    index === data.product_details.certificate_list.length - 1 ? "" : " / "
                                ]
                            }, index))
                    })
                ]
            }),
            !user.isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((_slug_module_default()).blurImage, " flex justify-between items-center px-4 py-4 mt-1"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-white text-sm",
                        children: " Login to see the Deal"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: ()=>dispatch(openDialog(true)),
                        destinationEvent: "Login/Register popup Opened",
                        styles: "bg-theme-orange text-white px-5 h-10 font-light text-sm",
                        children: "Login/Register"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "input rounded-[4px] p-3 mt-3",
                    style: {
                        background: "rgba(219, 107, 43, 0.15)"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-start justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[70%]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        outerProperties: "rounded border border-[#00000033] h-[39px]",
                                        properties: "placeholder:text-theme-black placeholder:text-[12px] h-[37px]",
                                        background: "transparent",
                                        placeholder: "Enter Your Bid QTY",
                                        suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[40px] h-[39px] flex items-center justify-center border-l border-l-[#C8BAB2]",
                                            children: "KG"
                                        }),
                                        onChange: handleChange,
                                        name: "bid_quantity",
                                        value: values.bid_quantity,
                                        onBlur: handleBlur,
                                        error: errors.bid_quantity,
                                        touched: touched.bid_quantity,
                                        maxLength: 20
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    styles: "bg-[#407BFF] text-white w-[28%] text-[12px]",
                                    height: 38,
                                    destinationEvent: "Confirmation popup Opened",
                                    borderRadius: 3,
                                    children: "Bid Now"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-theme-black flex justify-between justify-between",
                            children: [
                                data.payment_terms && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center w-[40%] mt-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "w-[15px] mr-2",
                                            src: "/APIDetails/Card.svg",
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                            className: "text-[12px]",
                                            children: [
                                                " ",
                                                data.payment_terms,
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                data.delivery_days && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center w-[60%] mt-2 ".concat(data.payment_terms && "justify-end"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "w-[15px] mr-2",
                                            src: "/APIDetails/Truck.svg",
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                            className: "text-[12px]",
                                            children: [
                                                " ",
                                                data.delivery_days,
                                                " days after order placement "
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var deal_card = (PDPDealCard);

// EXTERNAL MODULE: ./src/components/Layout/EnquirySuccess.tsx
var EnquirySuccess = __webpack_require__(6113);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/store/AuthSlice.js
var AuthSlice = __webpack_require__(5102);
;// CONCATENATED MODULE: ./src/components/APIDetails/direct-purchase.tsx






function DirectPurchase(param) {
    let { data , api , onBuyButtonClick , showPrice  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { enquiryState  } = (0,es/* useSelector */.v9)((state)=>state.core);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white rounded pb-2 mb-4 px-3 pt-3 md:mb-0 rounded-[5px]",
        style: {
            border: "0.5px solid rgba(170, 170, 170, 0.5)"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between py-2 px-2 lg:py-2 mb-[7px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-[12px] lg:w-[48%] font-[700]",
                        children: [
                            " ",
                            data.manufacturer_name ? data.manufacturer_name : "-",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[12px]",
                        children: data.country ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "w-[20px] mr-2",
                                    src: data.country.flag_link,
                                    alt: data.country.short_name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        " ",
                                        data.country.name,
                                        " "
                                    ]
                                })
                            ]
                        }) : "-"
                    })
                ]
            }),
            data.certificate_list.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between py-2 rounded-[2px] px-2 lg:py-2 bg-[#F7F7F7] mb-[7px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] lg:w-[48%]",
                        children: "Quality certificates"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] font-[700]",
                        children: data.certificate_list.map((certificate, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    certificate.name,
                                    index === data.certificate_list.length - 1 ? "" : " / "
                                ]
                            }, index))
                    })
                ]
            }),
            data.pharmacopoeia_grade_list.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between py-2 rounded-[2px] px-2 lg:py-2 bg-[#F7F7F7] mb-[6px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] lg:w-[48%]",
                        children: "Pharmacopeia grades"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] font-[700]",
                        children: data.pharmacopoeia_grade_list.map((certificate, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    certificate.name,
                                    index === data.pharmacopoeia_grade_list.length - 1 ? "" : " / "
                                ]
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center mb-[13px]",
                children: [
                    data.quantity_available && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between flex-col py-2 px-2 lg:py-2 lg:justify-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-[14px] font-[600]",
                                children: [
                                    " ",
                                    data.quantity_available,
                                    " ",
                                    data.quantity_available_unit_details.name,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[14px] font-light",
                                children: "Stock Available"
                            })
                        ]
                    }),
                    data.shipping_term_details && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between flex-col py-2 px-2 lg:py-2 lg:justify-start text-right",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-[14px] font-[600]",
                                children: [
                                    " ",
                                    data.shipping_term_details ? data.shipping_term_details.name : "-",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[14px] font-light",
                                children: "Shipping Terms"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-3 rounded-[3px]",
                style: {
                    background: "rgba(219, 107, 43, 0.15)"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between py-2 lg:py-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[16px] lg:w-[48%]",
                                children: "Price ($) "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-[16px] font-bold ".concat(!data.price && "blur-[3px]"),
                                children: [
                                    " $",
                                    data.price ? data.price : "XX",
                                    " "
                                ]
                            })
                        ]
                    }),
                    !showPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            styles: "bg-theme-orange text-white px-4",
                            height: 34,
                            borderRadius: 3,
                            width: "100%",
                            onClick: ()=>dispatch((0,AuthSlice/* handleAuthModal */.eD)(true)),
                            children: "Login to see Price"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between py-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                borderRadius: 3,
                                width: "48%",
                                height: 32,
                                styles: "bg-[#407BFF] text-white text-[15px]",
                                onClick: onBuyButtonClick,
                                children: "Buy"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "".concat("http://seller.apidrug.com/", "dashboard/fixed-price/create"),
                                target: "_blank",
                                className: "block w-[48%]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    borderRadius: 3,
                                    width: "100%",
                                    height: 32,
                                    styles: "bg-[#F55246] text-white text-[15px]",
                                    children: "Sell"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EnquirySuccess/* default */.Z, {
                show: enquiryState.showSuccessModal,
                user: enquiryState.responseData ? enquiryState.responseData.user : ""
            })
        ]
    });
}
/* harmony default export */ var direct_purchase = (DirectPurchase);

// EXTERNAL MODULE: ./src/store/CoreSlice.ts
var CoreSlice = __webpack_require__(1266);
// EXTERNAL MODULE: ./src/styles/Home/Home.module.css
var Home_module = __webpack_require__(8183);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(5444);
// EXTERNAL MODULE: ./src/components/General/Select.tsx + 47 modules
var Select = __webpack_require__(7418);
// EXTERNAL MODULE: ./src/validations/Enquiry.ts
var Enquiry = __webpack_require__(6578);
// EXTERNAL MODULE: ./src/components/Layout/EnquiryForm.tsx
var EnquiryForm = __webpack_require__(7625);
// EXTERNAL MODULE: ./src/components/General/TextArea.tsx
var TextArea = __webpack_require__(6965);
// EXTERNAL MODULE: ./src/components/General/FileInput.tsx
var FileInput = __webpack_require__(9403);
// EXTERNAL MODULE: ./src/components/General/DatePicker.tsx
var DatePicker = __webpack_require__(4085);
;// CONCATENATED MODULE: ./src/components/APIDetails/GetInTouch.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	border-radius : 0px;\n	width : 35px;\n	height : 35px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
















const StyledQuantitySuffix = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41eed899-0"
})(_templateObject());
function GetInTouch(param) {
    let { product , ID , CASNumber  } = param;
    let initialValues = {
        // Autocomplete fields
        product_string: product,
        country_string: "",
        product: ID,
        quantity: null,
        price: null,
        expected_date: null,
        unit: 1,
        message: "",
        required_manufacturer: "",
        shipping_terms: "",
        // selected fields
        expected_certificates: [],
        pharmacopoeia_grades: []
    };
    const [showCountryResults, setShowCountryResults] = (0,react.useState)(false);
    const [countryString, setCountryString] = (0,react.useState)("");
    const dispatch = (0,es/* useDispatch */.I0)();
    const { user  } = (0,es/* useSelector */.v9)((state)=>state.auth);
    const { countryList , certificateList , pharmacopoeiaGradesList , enquiryState , files  } = (0,es/* useSelector */.v9)((state)=>state.core);
    const { values , errors , handleSubmit , handleBlur , handleChange , touched , resetForm , setFieldValue  } = (0,formik_esm/* useFormik */.TA)({
        initialValues: initialValues,
        validationSchema: Enquiry/* default */.ZP,
        onSubmit: (values, action)=>{
            helpers/* default.consoleLog */.Z.consoleLog("jnjdwnj");
            const payload = {
                ...values
            };
            payload["attachment"] = files.length ? files[0].id : null;
            // In case a Product String is there but not selected any predefined product.
            if (payload.product_string !== "" && payload.product === null) {
                payload.product_text = payload.product_string;
                setFieldValue("product_text", payload.product_string);
            }
            if (user.isLoggedIn) {
                dispatch((0,CoreSlice/* submitEnquiry */.yW)(payload));
            } else {
                dispatch((0,CoreSlice/* openEnquiryModal */.Qy)(payload));
            }
        }
    });
    (0,react.useEffect)(()=>{
        dispatch((0,CoreSlice/* getCertificateList */.DC)());
        dispatch((0,CoreSlice/* getPharmacopoeiaGrades */.z8)());
    }, []);
    (0,react.useEffect)(()=>{
        if (enquiryState.showSuccessModal) {
            resetEnquiryForm();
        }
    }, [
        enquiryState.showSuccessModal
    ]);
    const handleCountrySearch = (event)=>{
        setCountryString(()=>event.target.value);
        setFieldValue("country_string", event.target.value);
        setShowCountryResults(()=>true);
        const params = {
            search: event.target.value
        };
        dispatch((0,CoreSlice/* getCountryList */.Jp)(params));
        if (event.target.value == "") setFieldValue("country", null);
    };
    const selectCountry = (data)=>{
        setCountryString(()=>data.name);
        setFieldValue("country_string", data.name);
        setFieldValue("country", data.id);
        setShowCountryResults(()=>false);
    };
    const handleCountryClear = ()=>{
        setCountryString(()=>"");
        values.country_string = "";
        setFieldValue("country_string", "");
        setFieldValue("country", null);
    };
    const resetEnquiryForm = ()=>{
        resetForm();
        setCountryString("");
        dispatch((0,CoreSlice/* setFileData */.$C)({
            data: [],
            action: "replace"
        }));
    };
    console.log(errors);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rounded-lg py-5 box-border",
                style: {
                    background: "rgba(103, 124, 187)",
                    boxShadow: "0px 3px 39px #EAE7E76C"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: "px-4 grid grid-cols-1 gap-4 md:px-10 py-4 lg:px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                disabled: true,
                                className: "mb-3",
                                label: "Product Name",
                                background: "#8798c9",
                                color: "white",
                                outerProperties: "rounded py-[10px]",
                                value: values.product_string,
                                properties: "placeholder:text-[#C3CCE4]"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                className: "mb-3",
                                label: "Quantity",
                                placeholder: "eg. 10",
                                background: "#8798c9",
                                color: "white",
                                outerProperties: "rounded py-0.5",
                                suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuantitySuffix, {
                                    className: "text-white bg-transparent m-1 text-sm flex justify-center items-center border-l border-[#A9B5D8]",
                                    children: "KG"
                                }),
                                onChange: handleChange,
                                name: "quantity",
                                value: values.quantity,
                                onBlur: handleBlur,
                                error: errors.quantity,
                                touched: touched.quantity,
                                properties: "placeholder:text-[#C3CCE4]"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            className: "mb-3",
                            label: "Budget",
                            placeholder: "eg. 220",
                            background: "#8798c9",
                            color: "white",
                            outerProperties: "rounded py-0.5",
                            suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuantitySuffix, {
                                className: "text-white bg-transparent p-2 m-1 text-sm flex justify-center items-center border-l border-[#A9B5D8]",
                                children: "$"
                            }),
                            onChange: handleChange,
                            name: "price",
                            value: values.price,
                            onBlur: handleBlur,
                            error: errors.price,
                            touched: touched.price,
                            properties: "placeholder:text-[#C3CCE4]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                label: "Target Market",
                                placeholder: "eg. USA",
                                search: true,
                                onInput: handleCountrySearch,
                                name: "country_string",
                                value: countryString,
                                background: "#8798c9",
                                color: "white",
                                outerProperties: "rounded ".concat(!countryString && "py-[11.5px]"),
                                error: errors.country_string,
                                touched: touched.country_string,
                                onBlur: (e)=>{
                                    setTimeout(()=>{
                                        setShowCountryResults(false);
                                        handleBlur(e);
                                    }, 300);
                                },
                                searchResults: showCountryResults && countryList.list.map((data, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " flex justify-between text-[12px] my-1 py-2 text-theme-black font-light cursor-pointer rounded items-center hover:bg-[#D4D9E7]/50 font-semibold",
                                        onClick: ()=>selectCountry(data),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "flex flex-col font-light",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: data.name
                                            })
                                        })
                                    }, index)),
                                suffix: countryString && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: handleCountryClear,
                                    className: "cursor-pointer text-white p-2 m-1 text-sm flex justify-center items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        strokeWidth: 1.5,
                                        stroke: "currentColor",
                                        className: "w-6 h-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            d: "M6 18L18 6M6 6l12 12"
                                        })
                                    })
                                }),
                                properties: "placeholder:text-[#C3CCE4]"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker/* default */.Z, {
                            className: "mb-3",
                            label: "Delivery Date",
                            background: "#8798c9",
                            color: "white",
                            outerProperties: "rounded py-0.5",
                            suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuantitySuffix, {
                                className: "text-white bg-transparent p-2 m-1 text-sm flex justify-center items-center border-l border-[#A9B5D8]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    strokeWidth: 1.5,
                                    stroke: "currentColor",
                                    className: "w-6 h-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
                                    })
                                })
                            }),
                            name: "expected_date",
                            onBlur: handleBlur,
                            error: errors.expected_date,
                            touched: touched.expected_date,
                            properties: "placeholder:text-[#C3CCE4]",
                            minimumDate: new Date(),
                            initialValue: values.expected_date,
                            onChange: (date)=>setFieldValue("expected_date", date)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            className: "mb-3",
                            label: "Required Manufacturer",
                            labelColor: "white",
                            background: "#8798c9",
                            color: "white",
                            outerProperties: "rounded py-[11px]",
                            onChange: handleChange,
                            name: "required_manufacturer",
                            value: values.required_manufacturer,
                            onBlur: handleBlur,
                            error: errors.required_manufacturer,
                            touched: touched.required_manufacturer
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "inline-block mb-1 text-white",
                                    children: " Certificates "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                    search: true,
                                    color: "white",
                                    placeholder: "eg. GMP, DMF",
                                    background: "#8798c9",
                                    additionalStyles: {
                                        border: "none",
                                        padding: "2px 0"
                                    },
                                    multi: true,
                                    suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuantitySuffix, {
                                        className: "text-white bg-transparent border-l border-[#A9B5D8] p-2 m-1 text-sm flex justify-center items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            strokeWidth: 1.5,
                                            stroke: "currentColor",
                                            className: "w-6 h-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
                                            })
                                        })
                                    }),
                                    items: certificateList.list,
                                    onChange: (selected)=>setFieldValue("expected_certificates", selected),
                                    error: errors.expected_certificates,
                                    placeholderColor: "#C3CCE4",
                                    placeholderStyles: {
                                        fontSize: 13,
                                        fontWeight: 300
                                    },
                                    name: "expected_certificates",
                                    value: values.expected_certificates,
                                    touched: touched.expected_certificates
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "inline-block mb-1 text-white",
                                    children: " Pharmacopoeia Grades "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                    search: true,
                                    color: "white",
                                    placeholder: "eg. USP, IP",
                                    background: "#8798c9",
                                    additionalStyles: {
                                        border: "none",
                                        padding: "2px 0"
                                    },
                                    multi: true,
                                    suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuantitySuffix, {
                                        className: "text-white bg-transparent border-l border-[#A9B5D8] p-2 m-1 text-sm flex justify-center items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            strokeWidth: 1.5,
                                            stroke: "currentColor",
                                            className: "w-6 h-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
                                            })
                                        })
                                    }),
                                    items: pharmacopoeiaGradesList.list,
                                    onChange: (selected)=>setFieldValue("pharmacopoeia_grades", selected),
                                    placeholderColor: "#C3CCE4",
                                    placeholderStyles: {
                                        fontSize: 13,
                                        fontWeight: 300
                                    },
                                    name: "pharmacopoeia_grades",
                                    value: values.pharmacopoeia_grades,
                                    error: errors.pharmacopoeia_grades,
                                    touched: touched.pharmacopoeia_grades
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "inline-block mb-1 text-white",
                                    children: " Attach a file "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FileInput/* default */.Z, {
                                    name: "attachment",
                                    uniqueID: "enquiry__attachment",
                                    disabled: files.length,
                                    error: errors.attachment,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex justify-between items-center bg-[#8798c9] py-[2px] rounded text-sm font-light pl-2 text-[gray]",
                                        children: [
                                            files.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-white opacity-[0.5]",
                                                children: "Browse"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "flex text-white opacity-[0.5]",
                                                children: [
                                                    files.length && helpers/* default.reduceStringLength */.Z.reduceStringLength(files[0].name),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        onClick: ()=>dispatch((0,CoreSlice/* deleteFile */._I)(files[0].id)),
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        strokeWidth: 1.5,
                                                        stroke: "currentColor",
                                                        className: "w-5 h-5 ml-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            d: "M6 18L18 6M6 6l12 12"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuantitySuffix, {
                                                className: "text-white bg-transparent border-l border-[#A9B5D8] p-2 m-1 text-sm flex justify-center items-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    strokeWidth: 1.5,
                                                    stroke: "currentColor",
                                                    className: "w-6 h-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        d: "M12 6v12m6-6H6"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            className: "mb-3",
                            label: "Shipping Terms",
                            labelColor: "white",
                            background: "#8798c9",
                            color: "white",
                            placeholder: "Enter Shipping terms",
                            outerProperties: "rounded py-[11px]",
                            properties: "placeholder:text-white placeholder:opacity-[0.5]",
                            onChange: handleChange,
                            name: "shipping_terms",
                            value: values.shipping_terms,
                            onBlur: handleBlur,
                            error: errors.shipping_terms,
                            touched: touched.shipping_terms
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea/* default */.Z, {
                                outerProperties: "w-full mt-3 pt-3 rounded placeholder:text-[#C3CCE4] placeholder:text-sm placeholder:font-light placeholder:text-[white]",
                                background: "#8798c9",
                                properties: "placeholder:text-white placeholder:opacity-[0.5]",
                                color: "white",
                                rows: 4,
                                placeholder: "Any Additional Comments?",
                                onChange: handleChange,
                                name: "message",
                                value: values.message,
                                onBlur: handleBlur
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            type: "submit",
                            styles: "w-full text-white bg-theme-orange h-12 mt-4",
                            children: " Submit "
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EnquiryForm/* default */.Z, {
                data: values,
                payload: values,
                countryList: countryList.fixedList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EnquirySuccess/* default */.Z, {
                show: enquiryState.showSuccessModal,
                user: enquiryState.responseData ? enquiryState.responseData.user : ""
            })
        ]
    });
}
/* harmony default export */ var APIDetails_GetInTouch = (GetInTouch);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/components/General/Modal.tsx
var Modal = __webpack_require__(8472);
;// CONCATENATED MODULE: ./src/components/APIDetails/Share.tsx

function Share_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width : 100%;\n    height : 40px;\n    border-radius : 4px;\n    border : 1px solid grey;\n    overflow-x : auto;\n    margin-right : 10px;\n"
    ]);
    Share_templateObject = function() {
        return data;
    };
    return data;
}




const StyledDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f759e071-0"
})(Share_templateObject());
function Share(param) {
    let { show , url , close  } = param;
    const [showToolTip, setShowToolTip] = (0,react.useState)(false);
    const [tooltipTitle, setTooltipTitle] = (0,react.useState)("Copy");
    // FUNCTIONS
    const copyURL = ()=>{
        navigator.clipboard.writeText(url);
        setTooltipTitle("Copied!");
        setTimeout(()=>{
            setTooltipTitle("Copy");
        }, 5000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        show: show,
        styles: "w-[90%] lg:w-2/5",
        transition: "animateup",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "content pt-4 pb-4 px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            className: "text-theme-black font-semibold text-2xl flex items-center justify-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    strokeWidth: 1.5,
                                    stroke: "currentColor",
                                    className: "w-6 h-6 mr-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        d: "M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"
                                    })
                                }),
                                "Share this Page"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            onClick: ()=>close(),
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            strokeWidth: 1.5,
                            stroke: "currentColor",
                            className: "w-6 h-6 cursor-pointer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                d: "M6 18L18 6M6 6l12 12"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDiv, {
                            className: "flex items-center justify-center my-10",
                            children: url
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                showToolTip && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-sm text-center bg-black bg-opacity-60 text-white py-1 absolute -top-10 right-0 rounded min-w-[100px]",
                                    children: [
                                        " ",
                                        tooltipTitle,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    onClick: copyURL,
                                    onMouseEnter: ()=>setShowToolTip(true),
                                    onMouseLeave: ()=>setShowToolTip(false),
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    strokeWidth: 1.5,
                                    stroke: "currentColor",
                                    className: "w-6 h-6 cursor-pointer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        d: "M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var APIDetails_Share = (Share);

// EXTERNAL MODULE: ./src/components/Home/FAQs.tsx + 2 modules
var FAQs = __webpack_require__(8164);
// EXTERNAL MODULE: ./src/components/SpotBuying/Requirements.tsx
var Requirements = __webpack_require__(3226);
// EXTERNAL MODULE: ./src/components/SpotBuying/OrderDetails.tsx + 2 modules
var OrderDetails = __webpack_require__(25);
// EXTERNAL MODULE: ./src/components/SuccessModal.tsx
var SuccessModal = __webpack_require__(9806);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/products/[slug].tsx




















function APIDetails(param) {
    let { data  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const { dealList: { list  } , orderPayload  } = (0,es/* useSelector */.v9)((state)=>state.core);
    const { user  } = (0,es/* useSelector */.v9)((state)=>state.auth);
    const [currentURL, setCurrentURL] = (0,react.useState)("");
    const [showShareModal, setShowShareModal] = (0,react.useState)(false);
    const [currentlyActiveTab, setCurrentlyActiveTab] = (0,react.useState)("product_information");
    const [requirementDetails, setRequirementDetails] = (0,react.useState)({});
    const [showRequirementDetailsPopup, setShowRequirementDetailsPopup] = (0,react.useState)(false);
    const [orderDetailsData, setOrderDetailsData] = (0,react.useState)({});
    const [showOrderDetailsPopup, setShowOrderDetailsPopup] = (0,react.useState)(false);
    const [showSuccessModal, setShowSuccessModal] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setCurrentURL(window.location.href);
        const mixPanelData = {
            productID: data.id,
            productName: data.name,
            hasFixedPrices: data.fixed_price_details.length > 0,
            hasDeals: data.deals_count > 0
        };
        MixPanel/* MixpanelTracking.getInstance */.n.getInstance().landedToPDP(mixPanelData);
    }, []);
    (0,react.useEffect)(()=>{
        dealList();
        router.replace(router.asPath);
    }, [
        user.isLoggedIn
    ]);
    (0,react.useEffect)(()=>{
        if (orderPayload.responseStatus === CoreSlice/* responseStates.SUCCESS */.Mz.SUCCESS) {
            setShowOrderDetailsPopup(false);
            setShowSuccessModal(true);
        }
    }, [
        orderPayload.responseStatus
    ]);
    // FUNCTIONS
    const dealList = ()=>{
        const params = {
            page: 1,
            product: data.id
        };
        dispatch((0,CoreSlice/* getDealList */.Ao)(params));
    };
    const openRequirementsDialog = (productName, price)=>{
        setRequirementDetails(()=>{
            return {
                productName: productName,
                price: price
            };
        });
        setShowRequirementDetailsPopup(true);
    };
    const openOrderDetails = (productName, price, quantity)=>{
        const decodedToken = helpers/* default.decodeToken */.Z.decodeToken(access_token/* default.getAccessToken */.Z.getAccessToken());
        setOrderDetailsData(()=>{
            return {
                productName: productName,
                price: price,
                quantity: quantity,
                buyerName: decodedToken.name,
                phone: decodedToken.phone,
                email: decodedToken.email
            };
        });
        setShowOrderDetailsPopup(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-theme-black lg:flex lg:justify-between items-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "".concat(data.name, " | APIdrug Platform")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "\n						Buy ".concat(data.name, " online ip bp usp in bulk. Best price of ").concat(data.name, ", All sellers for ").concat(data.name, ", manufacturers, sellers, \n						pharmaceutical raw materials, Pharma Ingredients, api exporters, traders, marketplace for apis, sell ").concat(data.name, " online\n						cas - ").concat(data.cas_number, " ").concat(data.molecular_formula ? " , formula - ".concat(data.molecular_formula) : "", " \n					")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:w-[56%]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "left-section ".concat((_slug_module_default()).leftSectionAlign),
                        style: {
                            background: "#F7F7F7",
                            borderBottomRightRadius: 9
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-start justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex justify-left items-start",
                                        children: [
                                            data.structural_formula_image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "image bg-white p-2 lg:p-4",
                                                style: {
                                                    borderRadius: 6
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "object-contain w-[80px] h-[80px] lg:w-[100px] lg:h-[100px]",
                                                    src: data.structural_formula_image.file_url,
                                                    alt: "product image"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "lg:text-left ".concat(data.structural_formula_image ? "ml-4 lg:ml-6" : ""),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                        className: "text-theme-black text-2xl lg:text-3xl font-semibold lg:my-8 lg:mt-0 lg:mb-4",
                                                        children: [
                                                            " ",
                                                            data.name,
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-sm lg:text-[18px]",
                                                        children: [
                                                            "CAS # ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "font-semibold",
                                                                children: [
                                                                    " ",
                                                                    data.cas_number,
                                                                    " "
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onClick: ()=>setShowShareModal(true),
                                        className: "w-[50px] drop-shadow-sm px-2 lg:px-4 py-2 rounded-[20px] bg-white w-[30px] lg:w-[60px] h-[35px] flex items-center justify-center cursor-pointer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            strokeWidth: 2,
                                            stroke: "currentColor",
                                            className: "w-5 h-5 text-theme-orange",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                d: "M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "content mt-6 bg-white rounded-[4px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((_slug_module_default()).tabsBorder, " whitespace-nowrap overflow-x-auto hide-scrollbar hide-scrollbar-2"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-start pt-4 text-theme-black px-5 lg:px-8",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[16px] md:text-[16px] md:text-normal pb-4 cursor-pointer font-light ".concat(currentlyActiveTab === "product_information" ? "border-b-[3px] border-theme-orange font-semibold" : ""),
                                                    onClick: ()=>setCurrentlyActiveTab("product_information"),
                                                    children: data.product_information.tab_name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[16px] md:text-[16px] mx-5 lg:mx-[50px] pb-4 cursor-pointer font-light ".concat(currentlyActiveTab === "technical_information" ? "border-b-[3px] border-theme-orange font-semibold" : ""),
                                                    onClick: ()=>setCurrentlyActiveTab("technical_information"),
                                                    children: data.technical_information.tab_name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[16px] md:text-[16px] md:text-normal pb-4 cursor-pointer font-light ".concat(currentlyActiveTab === "product_description" ? "border-b-[3px] border-theme-orange font-semibold" : ""),
                                                    onClick: ()=>setCurrentlyActiveTab("product_description"),
                                                    children: data.product_description.tab_name
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-5 lg:px-8 py-8 text-[16px]",
                                        children: data[currentlyActiveTab].fields.map((field, index)=>field.value && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex my-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "w-[30%] font-[500]",
                                                        children: [
                                                            " ",
                                                            field.name,
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "w-[70%] font-light",
                                                        dangerouslySetInnerHTML: {
                                                            "__html": field.value
                                                        }
                                                    })
                                                ]
                                            }, index))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hidden lg:block live-deals ".concat((_slug_module_default()).leftSectionAlign),
                        style: {
                            paddingTop: 50,
                            paddingBottom: 60
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-2xl font-semibold text-theme-blue pb-[30px]",
                                children: "Frequently Asked Questions (FAQs)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs/* default */.Z, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "right-section mt-10 pt-10 lg:w-[44%] mt-0 ".concat((_slug_module_default()).rightSectionAlign),
                style: {
                    background: "white"
                },
                children: [
                    list.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "live-deals",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "heading flex justify-between items-center mb-7 lg:mb-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                        className: "text-xl font-semibold flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((Home_module_default()).dot, " mb-1")
                                            }),
                                            "Bulk Deals"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "deals-card",
                                children: list.map((data, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(deal_card, {
                                            data: data,
                                            resetCard: dealList,
                                            user: user,
                                            openDialog: AuthSlice/* handleAuthModal */.eD
                                        })
                                    }, index))
                            })
                        ]
                    }),
                    data.fixed_price_details.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "live-deals ".concat(list.length !== 0 && "mt-10"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "heading flex justify-between items-center mb-7 lg:mb-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-xl font-semibold flex items-center",
                                        children: "Spot Price"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                ]
                            }),
                            data.fixed_price_details.map((fixedPrice)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "deals-card mb-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(direct_purchase, {
                                        data: fixedPrice,
                                        showPrice: user.isLoggedIn,
                                        onBuyButtonClick: ()=>openRequirementsDialog(data.name, fixedPrice)
                                    })
                                }, fixedPrice.id))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "live-deals ".concat(data.fixed_price_details.length > 0 ? "mt-10" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "heading flex justify-between items-center mb-7",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-xl font-semibold flex items-center",
                                        children: "Share Your Requirements"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "get-in-touch",
                                className: "deals-card",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(APIDetails_GetInTouch, {
                                    product: data.name,
                                    ID: data.id
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:hidden",
                        style: {
                            paddingTop: 50,
                            paddingBottom: 60
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-2xl font-semibold text-theme-blue pb-[30px]",
                                children: "Frequently Asked Questions (FAQs)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs/* default */.Z, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(APIDetails_Share, {
                url: currentURL,
                show: showShareModal,
                close: ()=>setShowShareModal(false)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Requirements/* default */.Z, {
                productName: requirementDetails.productName,
                data: requirementDetails.price,
                show: showRequirementDetailsPopup,
                onClose: ()=>{
                    setShowRequirementDetailsPopup(false);
                },
                onRequirementsSubmit: openOrderDetails
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDetails/* default */.Z, {
                productName: requirementDetails.productName,
                show: showOrderDetailsPopup,
                onClose: ()=>{
                    setShowOrderDetailsPopup(false);
                },
                data: orderDetailsData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessModal/* default */.Z, {
                show: showSuccessModal,
                image: "/OrderSuccess.svg",
                heading: "Order pending for approval",
                description: "Thank you for your purchase We will reach out to you with next steps.",
                onClose: ()=>{
                    dispatch((0,CoreSlice/* resetOrderPayload */.OJ)());
                    setShowSuccessModal(false);
                }
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var _slug_ = (APIDetails);


/***/ }),

/***/ 1739:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"leftSectionAlign":"_slug__leftSectionAlign__DjWK3","rightSectionAlign":"_slug__rightSectionAlign__LAiZt","blurImage":"_slug__blurImage__55Act","BlurSmallImage":"_slug__BlurSmallImage__ozxSd","tabsBorder":"_slug__tabsBorder__hv27r","rightSection":"_slug__rightSection__dhlk8"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [334,198,946,258,423,774,888,179], function() { return __webpack_exec__(5159); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);